var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_c('p',{staticClass:"leftWenzi"},[_vm._v(_vm._s(_vm.leftText))]),(_vm.leftText !== '' && _vm.showMore)?_c('a',{staticClass:"t-right",attrs:{"href":`type.html?type=${_vm.leftText}`}},[_c('span',{staticClass:"rightWenzi"},[_vm._v("MORE")])]):_vm._e()]),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }